import {
  SHOW_ALL,
  SHOW_PINNED_PORTS,
  SHOW_PINNED_SHIPS,
} from 'domain/Overview/constants'
import PropTypes from 'prop-types'

export default PropTypes.oneOf([SHOW_ALL, SHOW_PINNED_PORTS, SHOW_PINNED_SHIPS])
